import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UploadComponent } from './upload/upload.component';
import { DocumentsUploadStep1Component } from './upload/documents/step1/documents-upload-step1.component';
import { DocumentsUploadStep2Component } from './upload/documents/step2/documents-upload-step2.component';
import { DocumentsUploadStep3Component } from './upload/documents/step3/documents-upload-step3.component';
import { DocumentsUploadStep4Component } from './upload/documents/step4/documents-upload-step4.component';
import { AuthGuard } from '../../guards/auth.guard';
import { SuppliersUploadStep1Component } from './upload/suppliers/step1/suppliers-upload-step1.component';
import { SuppliersUploadStep2Component } from './upload/suppliers/step2/suppliers-upload-step2.component';
import { SuppliersUploadStep3Component } from './upload/suppliers/step3/suppliers-upload-step3.component';
import { SuppliersUploadStep4Component } from './upload/suppliers/step4/suppliers-upload-step4.component';
import { FactoringCreditAssignmentTemplateComponent } from './upload/FactoringCreditAssignment/template/factoring-credit-assignment-template.component';
import { UploadFileComponent } from './upload/files/upload-file.component';

const routes: Routes = [
	{
		path: 'upload',
		component: UploadComponent,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/documents/step1/:uploadContractType',
		component: DocumentsUploadStep1Component,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/documents/step2/:uploadContractType/:contractId',
		component: DocumentsUploadStep2Component,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/documents/step3/:uploadId/:uploadContractType/:contractId',
		component: DocumentsUploadStep3Component,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/documents/step4/:uploadId/:uploadContractType/:contractId',
		component: DocumentsUploadStep4Component,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/suppliers/step1',
		component: SuppliersUploadStep1Component,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/suppliers/step2/:associatedCompanyId',
		component: SuppliersUploadStep2Component,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/suppliers/step3/:associatedCompanyId/:uploadId',
		component: SuppliersUploadStep3Component,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/suppliers/step4/:associatedCompanyId/:uploadId',
		component: SuppliersUploadStep4Component,
	},
	{
		path: 'upload/factoringcreditassignment/template',
		component: FactoringCreditAssignmentTemplateComponent,
		canActivate: [AuthGuard],
	},
	{
		path: 'upload/files',
		component: UploadFileComponent,
		canActivate: [AuthGuard],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class UploadRoutingModule {}
